import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareSummaryRoute: InvariantJiraRoute = {
	name: 'software-summary',
	path: '/jira/software/projects/:projectKey/summary',
};
